<template>
  <Insights
    :module="'reviews'"
    :roleIdProp="roleIdProp"
    :citiesString="citiesString"
    :states="states"
    :moduleId="roleIdProp"
    insights-api-url="/api/reviews/insights"
    prompts-api-url="/api/user-prompts"
    :dataSourceOptions="dataSourceOptions"
  />
</template>

<script>
import Insights from '@/Shared/Insights/Insights.vue'

export default {
  name: 'ReviewsInsights',
  components: {
    Insights
  },
  props: {
    roleIdProp: {
      type: Number,
      required: true
    },
    citiesString: {
      type: String,
      default: ''
    },
    states: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dataSourceOptions: [
        { id: 'temporal_mensal', label: 'Análise temporal das avaliações (mensal)' },
        { id: 'temporal_anual', label: 'Análise temporal das avaliações (anual)' },
        { id: 'avaliacao_media', label: 'Avaliação Média dos Setores' },
        { id: 'sentimento', label: 'Sentimento das Avaliações' },
        { id: 'negocios_locais', label: 'Negócios Locais' },
        { id: 'problemas_comuns', label: 'Problemas Comuns' },
        { id: 'palavras_chave', label: 'Palavras-chave em Alta' }
      ]
    }
  }
}
</script>

<style scoped>
/* Estilos específicos para os Insights de reviews, se necessário */
</style>